<template>
  <div class="layerPop" id="popStock" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">증권출력</p>
        </div>
        <div class="popCon">
          <div class="tabStyle1 txtType">
            <table>
              <caption>
                증권정보
              </caption>
              <colgroup>
                <col width="150" />
                <col width="220" />
                <col width="150" />
                <col width="220" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" height="50">피보험자명<br />(Assured)</th>
                  <td>
                    {{ fnPolrResultdata.body.inspeKorNm }}
                    {{ fnPolrResultdata.body.inspeEngNm }}
                  </td>
                  <th scope="row">참고번호</th>
                  <td>
                    증권번호. {{ fnPolrResultdata.body.polNo }}
                    {{ fnPolrResultdata.body.refNoNm1 }}
                    {{ fnPolrResultdata.body.refnNo1 }}<br />
                    {{ fnPolrResultdata.body.refNoNm2 }}
                    {{ fnPolrResultdata.body.refnNo2 }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" height="50">보험가입금액</th>
                  <td colspan="3">
                    {{ fnPolrResultdata.body?.premCurCd }} (
                    {{ fnPolrResultdata.body.insVamt }}
                    {{ fnPolrResultdata.body?.premCurCd }} X
                    {{ fnPolrResultdata.body.hopPftRt }} % X
                    {{ fnPolrResultdata.body.aplExrt }} )
                  </td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd != '27000'">
                  <th scope="row" height="50">출발항명</th>
                  <td>{{ fnPolrResultdata.body.stpl }}</td>
                  <th scope="row">도착항명</th>
                  <td>{{ fnPolrResultdata.body.arar }}</td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd == '27000'">
                  <th scope="row" height="50">발송지</th>
                  <td>{{ fnPolrResultdata.body.stpl }}</td>
                  <th scope="row">도착지</th>
                  <td>{{ fnPolrResultdata.body.arar }}</td>
                </tr>
                <tr>
                  <th scope="row" height="50">목적물명</th>
                  <td colspan="3">{{ fnPolrResultdata.body.objDtl }}</td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd != '27000'">
                  <th scope="row" height="50">
                    조사인주소<br />
                    (Surveyor)
                  </th>
                  <td>
                    {{ fnPolrResultdata.body.insAmtPopaCoNm1 }}<br />
                    {{ fnPolrResultdata.body.insAmtPopaAdr1 }}<br />
                    {{ fnPolrResultdata.body.insAmtPopaEmail1 }}<br />
                    FAX.{{ fnPolrResultdata.body.insAmtPopaFaxNo1 }}<br />
                    TEL.{{ fnPolrResultdata.body.insAmtPopaTelNo1 }}
                  </td>
                  <th scope="row">
                    사고시지급지<br />
                    (Claim, payable at)
                  </th>
                  <td>
                    {{ fnPolrResultdata.body.insAmtPopaCoNm2 }}<br />
                    {{ fnPolrResultdata.body.insAmtPopaAdr2 }}<br />
                    {{ fnPolrResultdata.body.insAmtPopaEmail2 }}<br />
                    FAX.{{ fnPolrResultdata.body.insAmtPopaFaxNo2 }}<br />
                    TEL.{{ fnPolrResultdata.body.insAmtPopaTelNo2 }}
                  </td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd != '27000'">
                  <th scope="row" height="50">운송수단</th>
                  <td>{{ fnPolrResultdata.body.ftrnOdNm1 }}</td>
                  <th scope="row">항해일자</th>
                  <td>{{ fnPolrResultdata.body.tkffDt }}</td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd == '27000'">
                  <th scope="row" height="50">운송수단</th>
                  <td>{{ fnPolrResultdata.body.ftrnOdNm1 }}</td>
                  <th scope="row">운송기간</th>
                  <td>
                    {{ fnPolrResultdata.body.insBgnDt }} ~
                    {{ fnPolrResultdata.body.insEdDt }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" height="50">보험조건</th>
                  <td colspan="3">
                    {{ fnPolrResultdata.body.addAttrCon }}
                    {{ fnPolrResultdata.body.covCon }}
                  </td>
                </tr>
                <tr v-if="fnPolrResultdata.body.pdCd != '27000'">
                  <th scope="row" height="50">보험개시일</th>
                  <td colspan="3">{{ fnPolrResultdata.body.insBgnDt }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="sortWrap typePrint mgt30">
            <dl>
              <dt class="fw700">원본</dt>
              <dd>
                <div class="inpSlt w100p">
                  <button type="button" class="sltBtn" title="매수 선택">
                    <span>{{ state.ortxtCpno }}매</span>
                  </button>
                  <ul>
                    <li
                      v-for="(item, index) in state.ortxtCpnoList"
                      :key="index"
                    >
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('ortxtCpno', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  </ul>
                </div>
              </dd>
            </dl>
            <dl>
              <dt class="fw700">Invoice</dt>
              <dd>
                <div class="inpSlt w100p">
                  <button type="button" class="sltBtn" title="매수 선택">
                    <span>{{ state.invoiceCnt }}매</span>
                  </button>
                  <ul v-if="fnPolrResultdata.body.pdCd != '27000'">
                    <li
                      v-for="(item, index) in state.invoiceCntList"
                      :key="index"
                    >
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('invoiceCnt', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  </ul>
                  <ul v-if="fnPolrResultdata.body.pdCd == '27000'">
                    <li
                      v-for="(item, index) in state.invoiceCntList2"
                      :key="index"
                    >
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('invoiceCnt', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
            <dl>
              <dt class="fw700">복사여부</dt>
              <dd>
                <div class="inpSlt w100p">
                  <button type="button" class="sltBtn" title="매수 선택">
                    <span>{{ state.copyCnt }}매</span>
                  </button>
                  <ul>
                    <li v-for="(item, index) in state.copyCntList" :key="index">
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('copyCnt', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  </ul>
                </div>
              </dd>
            </dl>
            <div class="btnWrap w100">
              <button
                type="button"
                class="btnType sizeS colorRL"
                @click="printPol()"
              >
                <span>출력</span>
              </button>
            </div>
          </div>

          <div class="inpCheck mgt20">
            <input type="checkbox" id="except" v-model="state.hopPftOtptYn" />
            <label for="except" class="fs14 fc66">희망이익율 출력 제외</label>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="close()"><span>취소</span></a>
        </div>
        <button
          type="button"
          class="popClose"
          onclick="popClose(this);"
          @click="close()"
        >
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, reactive, inject, defineExpose } from "vue";
import * as codeList from "@/common/code";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import encDownload from "@/common/encDownload";

const isVisible = ref(false);
const axios = inject("axios");
const swalAlert = inject("swalAlert");

let fnPolrResultdata = reactive({});
const state = reactive({
  ortxtCpnoList: [], //원본
  invoiceCntList: [], //invoice
  invoiceCntList2: [], //invoice 27000
  copyCntList: [], //복사
  ortxtCpno: "2",
  invoiceCnt: "2",
  copyCnt: "2",
  biz_no: "",
});

const emits = defineEmits(["update:data", "close"]);

//open시 데이터 받아오는 부분
const open = (d) => {
  state.biz_no = sessionUserInfo.userInfo.biz_no;
  fnPolrResultdata = d;
  console.log("d", d);
  state.ortxtCpno = fnPolrResultdata.body.otptOrtxtCpno;
  console.log("state.ortxtCpno", state.ortxtCpno);

  // state.ortxtCpnoList = codeList.getPolCntCodeList;
  state.ortxtCpnoList = _.filter(
    state.ortxtCpnoList,
    (a) => a.code <= state.ortxtCpno
  );
  console.log(state.ortxtCpnoList);

  //출력 매수 제어
  //한솔제지(1048658322) 의 경우는 최초 출력부수 셋팅 예외처리.원본 2부, copy 5부, 인보이스 1부로 기본셋팅 변경
  if ("1048658322" == state.biz_no) {
    state.ortxtCpno = "2";
    state.copyCnt = "5";
    state.invoiceCnt = "1";
  }
  //27000 일때 Invoice 0/1
  if (fnPolrResultdata.body.pdCd == "27000") {
    state.invoiceCnt = "1";
  }
  isVisible.value = true;
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

const onSelectEvent = (selectId, data) => {
  console.log(data);
  if (selectId == "ortxtCpno") {
    state.ortxtCpno = data.code;
  } else if (selectId == "invoiceCnt") {
    state.invoiceCnt = data.code;
  } else if (selectId == "copyCnt") {
    state.copyCnt = data.code;
  }
};

const printPol = async (otptDiv) => {
  if (
    state.ortxtCpno == "0" &&
    state.invoiceCnt == "0" &&
    state.copyCnt == "0"
  ) {
    swalAlert("매수를 확인해 주세요!");
    return;
  }
  //증권 출력시 보내줘야하는 데이터
  let param = {
    ctrId: fnPolrResultdata.body.ctrId, // 계약ID
    endrHisStdNo: fnPolrResultdata.body.endrHisStdNo, // 배서이력기준번호
    endrNo: fnPolrResultdata.body.endrNo, // 배서번호
    polNo: fnPolrResultdata.body.polNo, // 증권번호
    pdCd: "", //fnPolrResultdata.body.pdCd, // 상품코드
    otptDiv: otptDiv,
    otptSh: "2",
    polEndrOtptDiv: "3",
    cpyOriNum: state.copyCnt,
    ortxtCpno: state.ortxtCpno, //원본
    invcNum: state.invoiceCnt, // 27000 제어
    hopPftOtptYn: state.hopPftOtptYn ? "N" : "Y", // 희망이익율 체크 기준으로 체크되면 "N", 안되면 "Y"
  };

  let Result = await axios.transaction("FNGCTGFO0175", param);
  // await axios.get("/download.do?addFileNm=" + Result.body.otptPth)
  _.startsWith(Result.body.otptPth, "/")
    ? true
    : (Result.body.otptPth = "/" + Result.body.otptPth);

  let sFile = splitFile(Result.body.otptPth);
  console.log("sFile");
  console.log(sFile);

  // await axios.download(
  //   "/download.do?addFileNm=" + sFile.filename + "&addFilePath=" + sFile.dirPath
  // );

  const encFilePath = await encDownload.encryptData(sFile.dirPath, true);
  const encFileName = await encDownload.encryptData(sFile.filename, true);

  await axios.download(
    "/downloadEnc.do?addFileNm=" + encFileName + "&addFilePath=" + encFilePath
  );

  axios.json("/logHisLdg.do", {
    memo: "증권출력성공",
    page: window.location.hash,
  });
};

function splitFile(path) {
  const filename = path.split("/").pop();
  const dirPath = path.substring(0, path.lastIndexOf("/")) + "/";
  return { filename, dirPath };
}

async function init() {
  state.ortxtCpnoList = codeList.getPolCntCodeList;
  state.invoiceCntList = codeList.getInvoiceCntCodeList;
  state.invoiceCntList2 = codeList.getInvoiceCntCodeList2;
  state.copyCntList = codeList.getCopyCntCodeList;

  console.log("init", state.ortxtCpnoList);
}

init();

defineExpose({ open, close });
</script>
